import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import theme from '../Pdf/components/theme';
import PeriodEndReportPage from './components/pdf/PeriodEndReportPage';
import PeriodEndReportDataPointsTable from './components/pdf/PeriodEndReportDataPointsTable';
import SectionTitle from './components/pdf/SectionTitle';
import {
  PeriodEndReportSectionPageProps,
  PeriodEndReportFundOverviewDataPoint,
} from './types';

const styles = StyleSheet.create({
  sectionTitle: {
    paddingBottom: theme.spacing(theme.spacingSizes.md),
  },
});

type Props = PeriodEndReportSectionPageProps & {
  dataPoints: Array<PeriodEndReportFundOverviewDataPoint>;
};

const FundOverview: FC<Props> = ({ dataPoints, sectionNumber, ...rest }) => {
  return (
    <PeriodEndReportPage {...rest} header={`0${sectionNumber} – Fund overview`}>
      <SectionTitle
        sectionNumber={sectionNumber}
        title="Fund overview"
        style={styles.sectionTitle}
      />
      <PeriodEndReportDataPointsTable dataPoints={dataPoints} />
    </PeriodEndReportPage>
  );
};

export default FundOverview;
